import AOS from 'aos';
import lazySizes from "lazysizes";
import './utils/lazybg';
import './modules/nav/nav';
import 'picturefill';
import './modules/search/search';
import './modules/hero-video/heroVideo';
import './modules/case-studies/casestudyimage-carousel';
import './modules/case-studies/filter';

document.createElement('picture');

AOS.init({
    once: true,
    duration: 1000,
});
const anchorOffset = 160; // Set your offset (e.g. header height)

function scrollToAnchorWithOffset(id) {
    const target = document.getElementById(id);
    if (!target) return;

    const elementPosition = target.getBoundingClientRect().top + window.scrollY;
    const offsetPosition = elementPosition - anchorOffset;

    window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
    });
}
// Handle anchor clicks
document.querySelectorAll('a[href*="#"]').forEach(link => {
    link.addEventListener('click', function(e) {
        const href = this.getAttribute('href');
        const hash = href.includes('#') ? href.split('#')[1] : null;

        // Skip if no hash or external link
        if (!hash || (href.startsWith('http') && !href.startsWith(location.origin))) return;

        const samePage = href.startsWith('#') || href.startsWith(window.location.pathname + '#');
        if (samePage) {
            e.preventDefault();
            scrollToAnchorWithOffset(hash);
            history.pushState(null, '', '#' + hash); // Optional: update URL hash
        }
    });
});

// Handle anchor scroll on page load
window.addEventListener('DOMContentLoaded', () => {
    const hash = window.location.hash;
    if (hash.length > 1) {
        const id = hash.substring(1);
        setTimeout(() => scrollToAnchorWithOffset(id), 50); // Delay to ensure layout is ready
    }
});
